// extracted by mini-css-extract-plugin
module.exports = {"button":"play-button_button__f9iep"};